@let s = style();

@if (!hideTrigger()) {
  <button
    mat-icon-button
    [matMenuTriggerFor]="menu"
    [disabled]="triggerDisabled()"
    [attr.data-testid]="triggerTestId()"
    aria-label="Open context menu">
    @if (triggerSvgIcon(); as svg) {
      <mat-icon
        [svgIcon]="svg"
        [style.transform]="s ? 'scale(' + s.scale + ')' : null"
        [style.fontSize.px]="s?.size" />
    } @else {
      <mat-icon
        [style.transform]="s ? 'scale(' + s.scale + ')' : null"
        [style.fontSize.px]="s?.size">
        {{ triggerIcon() }}
      </mat-icon>
    }
  </button>
}

<mat-menu
  #menu="matMenu"
  [xPosition]="xPosition()"
  [yPosition]="yPosition()"
  [class]="
    type() === 'small' ? 'orion-context-menu orion-context-menu--small' : 'orion-context-menu'
  ">
  <div class="orion-context-menu__items" [attr.data-testid]="testId() ?? null">
    @for (item of items(); track item.name) {
      @if (item.divider) {
        <mat-divider />
      } @else if (item.subMenu) {
        <button
          mat-menu-item
          [disabled]="item.disabled"
          [attr.data-testid]="itemTestId(item)"
          [matMenuTriggerFor]="item.subMenu">
          @if (item.svgIcon) {
            <mat-icon [svgIcon]="item.svgIcon" />
          } @else if (item.icon) {
            <mat-icon>{{ item.icon }}</mat-icon>
          }
          {{ item.label | translate }}
        </button>
      } @else {
        <button
          mat-menu-item
          [disabled]="item.disabled"
          [attr.data-testid]="itemTestId(item)"
          (click)="onItemClick(item)">
          @if (selectionMode() === 'radio') {
            <mat-icon [class.is-selected]="item.selected">
              {{ item.selected ? 'radio_button_checked' : 'radio_button_unchecked' }}
            </mat-icon>
          } @else if (item.selected) {
            <mat-icon>check</mat-icon>
          } @else if (item.svgIcon) {
            <mat-icon [svgIcon]="item.svgIcon" />
          } @else if (item.icon) {
            <mat-icon>{{ item.icon }}</mat-icon>
          }
          {{ item.label | translate }}
        </button>
      }
    }
  </div>
</mat-menu>
